<template>
	<!-- 推荐商品（橱窗中商品） -->
	<div class="product-list">
		<div v-if="goodsLoading">
			<el-skeleton :loading="goodsLoading" animated>
				<template slot="template">
					<div style="display: flex;">
						<div style="margin-right: 20px;padding: 15px;" v-for="(item,index) in 4" :key="index">
							<el-skeleton-item variant="image" style="width: 200px; height: 200px;" />
							<div style="padding-top: 10px;">
								<el-skeleton-item variant="h3" style="width: 50%;" />
								<div class="product-price">
									<el-skeleton-item variant="text" style="margin-right: 16px;" />
									<el-skeleton-item variant="text" style="width: 30%;" />
								</div>
							</div>
						</div>
					</div>
				</template>
			</el-skeleton>
		</div>
		<div class="product-item" v-for="product in products" :key="product.id" @click="handleDetail(product)" v-else>
			<div class="product-image" :style="{height:productItemWidth+'px !important'}">
				<img :src="product.small">
			</div>
			<div style="padding: 15px;">
				<div class="product-name" :title="product.goodsName">{{ product.goodsName }}</div>
				<div style="display: flex;align-items: center;justify-content: space-between;">
					<div class="product-price">
						<span>{{currencySymbol}}</span>
						<span style="margin-left: 3px;">{{ product.price.toFixed(2) }}</span>
					</div>
					<div class="product-sale">
						{{$t('sales')}}：{{ product.buyCount }}
					</div>
				</div>
			</div>
			<!-- 选择货源按钮 -->
			<div class="select-source-btn-container" v-show="isShowBuy">
				<el-button type="danger" size="medium" class="show-buy-btn" @click.stop="selectSource(product)">
					{{ $t('selectThisSource') }}
				</el-button>
			</div>
		</div>

		<div class="nodata" v-if="products.length==0&&!goodsLoading">
			<img src="/icon/common/nodata.png">
			<span>{{$t('noData')}}</span>
		</div>
	</div>
</template>

<script>
	import storage from "@/utils/storage.js";
	import goodsApi from '@/api/product'
	export default {
		name: 'ProductList',
		props: {
			isShowBuy: {
				type: Boolean,
				default: false
			},
			categoryId: {
				type: String,
				default: null
			}
		},
		data() {
			return {
				productItemWidth: 0,
				goodsLoading: true, //是否显示骨架
				products: [],
				currencySymbol: '',
				params: {
					pageNumber: 1,
					pageSize: 20,
					notConvert: true,
					order: "desc",
					sort: 'releaseTime'
				}
			}
		},
		methods: {
			init() {
				this.products = [];
				this.goodsLoading = true;
				this.currencySymbol = storage.getCurrencySymbol();
				this.getGoodsList();
			},
			async getGoodsList() {
				var params = {
					...this.params,
					rateCode: storage.getCurrency()
				}
				if (this.categoryId && this.categoryId != 'all') {
					params.categoryId = this.categoryId;
				}
				const res = await goodsApi.getGoodsList(params);
				this.goodsLoading = false;
				if (res.result.total > 0) {
					this.products = res.result.records;
				}
				// 获取product-item的宽度
				this.$nextTick(() => {
					this.getProductItemWidth();
				});
			},
			//跳转商品详情页
			handleDetail(row) {
				if (!this.isShowBuy) {
					window.open('/product-detail?goodsId=' + row.id)
				}
			},
			selectSource(product) {
				// 选择货源的处理逻辑
				console.log('选择了货源:', product);
				this.$message.info('选中了这个货源，直接添加到购物车？')
				// 可以在这里添加具体的选择逻辑，比如添加到购物车或发送请求
			},
			// 获取product-item的宽度
			getProductItemWidth() {
				// querySelector只会返回匹配的第一个元素，符合需求
				const productItem = document.querySelector('.product-item');
				if (productItem) {
					// 获取元素的宽度
					this.productItemWidth = productItem.offsetWidth;
				}
			}
		}
	}
</script>

<style scoped>
	.product-list {
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
		gap: 15px;
		max-width: 1200px;
		margin: 0 auto 20px auto;
	}

	.product-item {
		border: 1px solid #e0e0e0;
		border-radius: 8px;
		text-align: center;
		transition: all 0.3s ease;
		position: relative;
		cursor: pointer;
	}

	.product-item:hover {
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
		transform: translateY(-2px);
	}

	/* 选择货源按钮样式 */
	.select-source-btn-container {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: 2;
		opacity: 0;
		transition: opacity 0.3s ease;
		pointer-events: none;
	}

	.show-buy-btn {
		background-color: #D9001B;
		border-color: #D9001B;
	}

	.product-item:hover .select-source-btn-container {
		opacity: 1;
		pointer-events: auto;
	}

	/* 确保按钮在图片上方显示 */
	.product-image {
		position: relative;
		z-index: 1;
	}

	.product-image {
		height: 240px;
		display: flex;
		align-items: center;
		justify-content: center;
		overflow: hidden;
	}

	.product-image img {
		max-width: 100%;
		max-height: 100%;
		object-fit: contain;
		transition: transform 0.3s ease;
		border-radius: 8px;
	}

	.product-item:hover .product-image img {
		transform: scale(1.05);
	}

	.product-name {
		font-size: 15px;
		color: #333;
		margin-bottom: 10px;
		height: 40px;
		line-height: 20px;
		overflow: hidden;
		text-overflow: ellipsis;
		text-align: left;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}

	.product-price {
		font-size: 20px;
		font-weight: bold;
		color: #F59A23;
		text-align: left;
	}

	.product-sale {
		font-size: 14px;
		color: #999;
	}
</style>